import { createFrontendModule } from '@backstage/frontend-plugin-api';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import { optionalStringConfig } from '../shared/configSchema';
import { techdocsMessages } from './translations';

/**
 * TechDocs with the Docs index of the v2 design (Story 5.4, AC-13): only the
 * index page loader is replaced; the route, the title and the reader stay
 * the plugin's. `publishGuideUrl` (optional, under `app.extensions`) is the
 * guide the "Como publicar" link opens; unset, the link is not rendered.
 */
export const byxTechdocsPlugin = techdocsPlugin.withOverrides({
  extensions: [
    techdocsPlugin.getExtension('page:techdocs').override({
      configSchema: {
        publishGuideUrl: optionalStringConfig,
      },
      factory: (originalFactory, { config }) =>
        originalFactory({
          params: {
            loader: async () => {
              const { ByxDocsPage } = await import('./ByxDocsPage');
              return (
                <ByxDocsPage
                  initialFilter={config.initialFilter}
                  publishGuideUrl={config.publishGuideUrl}
                />
              );
            },
          },
        }),
    }),
  ],
});

/**
 * pt-BR texts of TechDocs (index and reader). The app's translations input
 * only accepts extensions of the app plugin itself.
 */
export const docsTranslationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [techdocsMessages],
});
